import {
  UserRoleObject
} from '@/types/model';
import { PaginatedResponse, apiClient, QueryParams } from '@/services/apiClient.ts';

export const rolesService = {
  async getRoles(params: QueryParams = {}): Promise<PaginatedResponse<UserRoleObject>> {
    return apiClient.getPaginated<UserRoleObject>('/roles', params);
  },
};
